import React from 'react'
import Stack from '@mui/material/Stack'
import Snackbar from '@mui/material/Snackbar'
import Alert from '@mui/material/Alert'
import AlertTitle from '@mui/material/AlertTitle'

const SNACKBAR_TITLE_BY_SEVERITY = {
    success: '완료',
    info: '안내',
    warning: '확인 필요',
    error: '오류',
}

export default function Snackbars(props) {
    const handleClose = props.handleClose || props.onClose
    const severity = props.severity || 'info'
    const title = SNACKBAR_TITLE_BY_SEVERITY[severity]

    return (
        <Stack spacing={2} sx={{ width: '100%' }}>
            <Snackbar 
                anchorOrigin={{ vertical: "top", horizontal: "center" }}
                key={`top,center`}
                open={props.open} 
                autoHideDuration={3000} 
                onClose={handleClose}
                sx={{ mt: 1.5 }}
            >
                <Alert
                    elevation={0}
                    variant="filled"
                    severity={severity}
                    sx={{ width: '100%' }}
                >
                    {title ? <AlertTitle>{title}</AlertTitle> : null}
                    {props.message}
                </Alert>
            </Snackbar>
        </Stack>
    )
}
